module.exports = __webpack_public_path__ + "static/media/apollor_diagnostics_kanchrapara.441ad492.png";